<div class="h-100 d-flex justify-content-end align-items-center gap-12">
  @if (isStopButtonVisible()) {
    <i class="cp far fa-stop-circle text-error-r3 fs-4" (click)="onClick('stop')" tooltip="End this task permanently"> </i>
  }

  @if (isPauseButtonVisible()) {
    <i class="cp fas fa-pause text-warning-w3 fs-6" (click)="onClick('pause')" tooltip="Temporarily skip scheduled tests; resume anytime"> </i>
  }

  @if (isResumeButtonVisible()) {
    <i class="cp fas fa-play text-primary-p4 fs-6" (click)="onClick('resume')" tooltip="Continue from the next scheduled slot"> </i>
  }

  @if (isHideButtonVisible()) {
    <i
      class="cp far"
      [ngClass]="hiddenMode() ? 'fa-eye' : 'fa-eye-slash'"
      (click)="onClick(hiddenMode() ? 'visible' : 'hide')"
      [tooltip]="hiddenMode() ? 'Show' : 'Hide'">
    </i>
  }

  <i class="cp far fa-clone" (click)="onClick('clone')" tooltip="Clone this task"> </i>
  <i class="cp icon-test-results" (click)="onClick('testResults')" tooltip="View test results"> </i>
</div>
